import { ScrutinyTab } from '../ScrutinyTab';
import { Button } from 'primereact/button';
import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { getAllDetails, postAllData } from '../../../service/ProductService';
import { SAVEDEGREEADDITIONSCRUTINY, SAVEREENTRYSCRUTINY, SCRUTINYAPPTRANSFER, SCRUTINYBYRNO, SEARCHAPPLICATIONSREENTRY } from '../../../config/ApiConstant';
import { REENTRYNAME } from '../../../appconfig/Settings';
import { convertDateTime, formatDate, formatMonth } from '../../../appconfig/AppHelper';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import Loader from '../../../components/Loadeer/Loader';
import FormWizard from 'react-form-wizard-component';
import 'react-form-wizard-component/dist/style.css';
import { Checkbox } from 'primereact/checkbox';
import ScrutinySuccessModal from '../../../components/Modal/ScrutinySuccessModal';
import { InputTextarea } from 'primereact/inputtextarea';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { RadioButton } from 'primereact/radiobutton';
export const ReEntryScrutinySteps = () => {
    document.title = 'Re-Entry Scrutiny | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    //scrutinyRemainingList

    const [applicationDetails, setApplicationDetails] = useState<any>({});
    const [scrutinyDetails, setScrutinyDetails] = useState<any>({});

    //currrent Yeat
    const [currentYear, setCurrentYear] = useState<any>(new Date().getFullYear());

    //tabIndex
    const [activeIndex, setActiveIndex] = useState<any>();

    //role
    const [roleName, setRoleName] = useState<any>(null);

    //name
    const [userName, setUserName] = useState<string>('');

    //loaders
    const [pageLoad, setPageLoad] = useState<boolean>(true);

    //scrutiny check dialog
    const [scrutinyCheckDialog, setScrutinyCheckDialog] = useState<boolean>(false);
    const [saveButtonLoader, setSaveButtonLoader] = useState<boolean>(false);
    const [successDialog, setSuccessDialog] = useState<boolean>(false);
    const [successDetails, setSuccessDetails] = useState<any>({});

    //scrutinyCheckBtnTitle
    const [scrutinyCheckBtnTitle, setScrutinyCheckBtnTitle] = useState<any>(null);
    const [scrutinyCheckBtnSpinner, setScrutinyCheckBtnSpinner] = useState<boolean>(false);

    //check All
    const [checkAll, setCheckAll] = useState<boolean>(false);

    const { rNo, fileNo, status }: any = useParams();

    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');
        let name: any = localStorage.getItem('name');

        //Token Decode
        if (!window.cn(token)) {
            if (!window.cn(role)) {
                let roleNm = role;
                let selectedTab = atob(status);
                setActiveIndex(Number(selectedTab));
                setRoleName(roleNm);
                setUserName(name);

                if (!window.cn(fileNo) && !window.cn(rNo)) {
                    let fileNumber: any = atob(fileNo);
                    let rNumber: any = atob(rNo);

                    searchScrutiny(fileNumber, rNumber);
                }
            }
        }
    }, [status]);

    //seasr serutiny api
    const searchScrutiny = async (fileNo: any, rNo: any) => {
        try {
            setPageLoad(true);

            const response = await getAllDetails(SEARCHAPPLICATIONSREENTRY + '?SrNo=' + fileNo);
            if (response) {
                setApplicationDetails(response);

                try {
                    const innerResponse = await getAllDetails(SCRUTINYBYRNO + '?RNo=' + rNo + '&applicationTypeName=' + REENTRYNAME);
                    if (innerResponse) {
                        setScrutinyDetails(innerResponse);
                    }
                } catch (error: any) {
                    if (error.response) {
                        //Spinner False and Set Toast
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                    }
                }

                setPageLoad(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //handle change
    const handleChange = (e: any, name: string) => {
        let val: any = '';
        if (name === 'NMCase') {
            val = e;
        } else {
            let checked;
            if (e.checked === true) {
                checked = 1;
            } else {
                checked = 0;
            }
            val = checked;
        }
        setScrutinyDetails({ ...scrutinyDetails, [name]: val });

        const updatedDetails = {
            ...scrutinyDetails,
            [name]: val
        };

        const allChecked = Object.entries(updatedDetails).every(([key, value]) => {
            return key === 'NMCase' || value === 1;
        });

        setCheckAll(allChecked);
    };

    //handle All check change
    const handleCheckAll = (e: any) => {
        let val = e.checked === true ? 1 : 0;

        const updatedDetails = {
            ...scrutinyDetails,
            RegNo: val,
            RegDt: val,
            Qualn: val,
            RDt: val,
            FeePaid: val,
            ResLoc: val,
            Tcert: val,
            RCert: val,
            WSign: val,
            WRegno: val
        };

        setScrutinyDetails(updatedDetails);
        setCheckAll(e.checked);
    };

    //handleNoteChnage
    const handleNoteChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';
        setScrutinyDetails({ ...scrutinyDetails, [name]: val });
    };

    //open scrutiny Check dialof
    const scrutinyCheckOpen = (btnName: string) => {
        setScrutinyCheckDialog(true);
        setScrutinyCheckBtnTitle(btnName);
    };

    //const hidescrutinyCheckDialog
    const closeScrutinyCheckDialog = () => {
        setScrutinyCheckDialog(false);
    };

    //saveScrutiny
    const saveScrutiny = async () => {
        try {
            setSaveButtonLoader(true);

            // Degree Object Remove If Exist
            if (scrutinyDetails?.degree !== undefined) {
                delete scrutinyDetails.degree;
            }

            let allData = { ...scrutinyDetails };

            //Request Data
            let requestData = allData;
            requestData['RNo'] = atob(rNo);

            if (roleName == 'Scrutiny Manager') {
                requestData['prepared_by'] = userName;
            }

            if (roleName == 'Sub Registar') {
                requestData['approved_by'] = userName;
            }
           

            const response = await postAllData(SAVEREENTRYSCRUTINY, requestData);
            if (response) {
                setSuccessDetails(response);
                setSaveButtonLoader(false);

                setScrutinyDetails({});

                successDetailfn();
            }
        } catch (error: any) {
            if (error.response) {
                setSaveButtonLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    const successDetailfn = () => {
        if (successDetails && !window.cn(successDetails)) {
            setTimeout(() => {
                setSuccessDialog(true);
            }, 1000);
        }
    };

    // Modal Goto App Call
    const goToApp = () => {
        setSuccessDialog(false);
        navigate(`/app/scrutiny/re-entry-scrutiny/${btoa(activeIndex)}`);
    };

    // Get Name
    let name = `${!window.cn(applicationDetails?.StudL) ? applicationDetails?.StudL : ''} ${!window.cn(applicationDetails?.StudF) ? applicationDetails?.StudF : ''} ${!window.cn(applicationDetails?.StudM) ? applicationDetails?.StudM : ''}`;

    //view documensts
    const viewDocuments = () => {
        const docUrl = `/app/scrutiny/viewOtherDocument/${fileNo}/${window.btoa(REENTRYNAME)}/${rNo}`;
        window.open(docUrl, '_blank');
    };

    //check Scrutiny back to verification or pending
    const checkScrutiny = async (status: any) => {
        try {
            setScrutinyCheckBtnSpinner(true);

            //Request Data
            let requestData = {
                RNo: atob(rNo),
                reentryAppScrutinyStatus: status
            };
            //Api Call
            const response = await postAllData(SCRUTINYAPPTRANSFER, requestData);
            if (response) {
                setScrutinyCheckBtnSpinner(false);
                setScrutinyCheckDialog(false);
                setScrutinyDetails({});

                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setTimeout(() => {
                    navigate(`/app/scrutiny/re-entry-scrutiny/${btoa(activeIndex)}`);
                }, 1500);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setScrutinyCheckBtnSpinner(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    // get Year Difference
    const lastVYear = new Date(applicationDetails.LastVDate).getFullYear();
    const yearDiff = currentYear - lastVYear;
    let checkCase = false;
    let reEntryTxt = '';
    if (yearDiff >= 10 || applicationDetails?.DegNm === 'Qualified') {
        checkCase = true;
        scrutinyDetails.NMCase = 2;
        reEntryTxt = 'Put the Application Before Executive committee for Re-Entry in the Register of pharmacists of his/her name removed under section 34(2) if agreed.';
    } else {
        scrutinyDetails.NMCase = 1;
        reEntryTxt = 'The Application may be Considered for Re-Entry in the Register of Pharmacists of his / her Name Removed Under Section 34(2) if agreed.';
    }

    return (
        <>
            <ScrutinyTab mainTabLabel="Scrutiny (Re Entry)" />

            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Scrutiny'} pageName={'Re-Entry Scrutiny'} pageTitle={'Re-Entry Scrutiny'} goToPage={true} />

            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="grid ">
                            <div className="field col-12 md:col-5">
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Full Name :{' '}
                                    </b>
                                    <p className="detail_name">{name}</p>
                                </div>

                                <div className="flex">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Date :
                                    </b>
                                    <p className="detail_name">{!window.cn(applicationDetails?.EntDt) ? formatDate(applicationDetails?.EntDt) : ''}</p>
                                </div>
                            </div>
                            <div className="field  col-12 md:col-3">
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        File No :
                                    </b>
                                    <p className="detail_name">{applicationDetails?.SrNo}</p>
                                </div>
                                <div className="flex">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Verified By :
                                    </b>
                                    <p className="detail_name">{!window.cn(applicationDetails?.verified_by) ? applicationDetails?.verified_by : ''}</p>
                                </div>
                            </div>
                            <div className="field flex flex-column col-12 md:col-4 align-items-end">
                                {!window.cn(applicationDetails?.Image) && (
                                    <img
                                        src={applicationDetails?.Image}
                                        style={{
                                            border: '1px solid black'
                                        }}
                                        alt="User"
                                        width={'120px'}
                                    />
                                )}
                                <div className="flex mt-3">
                                    <Button label="View Document" onClick={() => viewDocuments()}></Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <FormWizard
                            stepSize="sm"
                            nextButtonTemplate={(handleNext) => (
                                <>
                                    <Button label="Next" onClick={handleNext} className="ml-2"></Button>
                                </>
                            )}
                            backButtonTemplate={(handlePrevious) => (
                                <>
                                    <Button label="Back" onClick={handlePrevious}></Button>
                                </>
                            )}
                            finishButtonTemplate={(handleComplete) => <></>}
                        >
                            <FormWizard.TabContent title="">
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8"></div>

                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={checkAll} onChange={(e: any) => handleCheckAll(e)}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data">Check All</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">1. Registration No :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.RegNo == 1 ? true : false} onChange={(e: any) => handleChange(e, 'RegNo')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.RegNo) ? applicationDetails?.RegNo : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">2. Registration Date :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.RegDt == 1 ? true : false} onChange={(e: any) => handleChange(e, 'RegDt')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.EntDt) ? formatDate(applicationDetails?.EntDt) : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">3. Qualification :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Qualn == 1 ? true : false} onChange={(e: any) => handleChange(e, 'Qualn')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.DegNm) ? applicationDetails?.DegNm : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">4. Date of Removal of his/her Name :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.RDt == 1 ? true : false} onChange={(e: any) => handleChange(e, 'RDt')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.LastVDate) ? formatDate(applicationDetails?.LastVDate) : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">5. Whether requisite fees are paid ? Mention fee receipt No. and Date :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.FeePaid == 1 ? true : false} onChange={(e: any) => handleChange(e, 'FeePaid')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.bill) && !window.cn(applicationDetails?.bill?.BillNo) ? applicationDetails?.bill?.BillNo : ''}</p>
                                            <p className="scrutiny_data ml-2">{!window.cn(applicationDetails?.bill) && !window.cn(applicationDetails?.bill?.billDt) ? 'Dt : ' + formatDate(applicationDetails?.bill?.billDt) : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data"> 6. Whether the Place Of Work and Place Of Residence is Located in Guajrat State ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ResLoc == 1 ? true : false} onChange={(e: any) => handleChange(e, 'ResLoc')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3"></div>
                                </div>

                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">7. Whether necessary true copy of Qualification Certificate is attached ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Tcert == 1 ? true : false} onChange={(e: any) => handleChange(e, 'Tcert')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">8. Whether true Copy of Registration Certificate is attached ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.RCert == 1 ? true : false} onChange={(e: any) => handleChange(e, 'RCert')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">9. Whether Signature of witness and His/ Her Address is Given ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.WSign == 1 ? true : false} onChange={(e: any) => handleChange(e, 'WSign')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">10. Whether Registration No. of witness Stated ? Whether it is renewed up to date ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.WRegno == 1 ? true : false} onChange={(e: any) => handleChange(e, 'WRegno')}></Checkbox>
                                    </div>
                                </div>

                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-12">
                                        <p className="scrutiny_data">{reEntryTxt}</p>
                                    </div>
                                </div>

                                <div className="grid">
                                    <div className="field col-12 md:col-8">
                                        {roleName === 'Scrutiny Manager' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Prepared Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.PNote} name="PNote" onChange={(e) => handleNoteChange(e, 'PNote')} rows={4}></InputTextarea>
                                                </div>
                                                {roleName === 'Admin' ? (
                                                    ' '
                                                ) : (
                                                    <div className="scrutiny-note-label">
                                                        {' '}
                                                        <label>
                                                            Approval Note : &nbsp;
                                                            {scrutinyDetails?.ANote}
                                                        </label>
                                                        {!window.cn(scrutinyDetails?.prepared_by) && (
                                                            <>
                                                                <br />

                                                                <label>
                                                                    Prepared By : &nbsp;
                                                                    {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                    {convertDateTime(scrutinyDetails?.prepared_time)}
                                                                </label>
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName === 'Sub Registar' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Approval Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.ANote} name="ANote" onChange={(e) => handleNoteChange(e, 'ANote')} rows={4}></InputTextarea>
                                                </div>

                                                {roleName === 'Admin' ? (
                                                    ''
                                                ) : (
                                                    <>
                                                        <div className="scrutiny-note-label">
                                                            <label>
                                                                Prepared Note : &nbsp;
                                                                {scrutinyDetails?.PNote}
                                                            </label>

                                                            {!window.cn(scrutinyDetails?.prepared_by) && (
                                                                <>
                                                                    <br />

                                                                    <label>
                                                                        Prepared By : &nbsp;
                                                                        {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.prepared_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                           
                                                            {!window.cn(scrutinyDetails?.approved_by) && (
                                                                <>
                                                                    <label>
                                                                        Approved By : &nbsp;
                                                                        {scrutinyDetails?.approved_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.approved_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>

                                    <div className="field col-12 md:col-2 mt-5" style={{ marginLeft: '3%' }}>
                                        {roleName == 'Scrutiny Manager' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption1" checked={scrutinyDetails?.Preparedby == 1 ? true : false} onChange={(e: any) => handleChange(e, 'Preparedby')}></Checkbox>
                                                    <label htmlFor="checkOption1">Prepared</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName == 'Sub Registar' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption3" checked={scrutinyDetails?.Approvedby == 1 ? true : false} onChange={(e: any) => handleChange(e, 'Approvedby')}></Checkbox>
                                                    <label htmlFor="checkOption3">Approval</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">Execcutive Commitee Meeting No. 83rd</p>
                                        <p className="scrutiny_data"> Date : 01/02/90</p>
                                        <p className="scrutiny_data"> Resolution No 3</p>
                                        <p className="scrutiny_data">Be Restored under section34(2) under the Pharmacy Act, 1948</p>
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <div>
                                            {checkCase === false ? (
                                                <div className="grid">
                                                    <div className="col-12 md:col-4 lg:col-4">
                                                        <div className="field-radiobutton">
                                                            <RadioButton inputId="option1" name="option" value={1} checked={scrutinyDetails?.NMCase === 1} onChange={(e) => handleChange(e.value, 'NMCase')} />
                                                            <label htmlFor="option1">Normal Case</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 md:col-4 lg:col-4">
                                                        <div className="field-radiobutton">
                                                            <RadioButton inputId="option2" name="option" value={2} checked={scrutinyDetails?.NMCase === 2} onChange={(e) => handleChange(e.value, 'NMCase')} />
                                                            <label htmlFor="option2">Meeting Case</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="grid">
                                                    <div className="col-12 md:col-4 lg:col-4">
                                                        <div className="field-radiobutton">
                                                            <RadioButton inputId="option1" name="option" value={1} checked={scrutinyDetails?.NMCase === 1} onChange={(e) => handleChange(e.value, 'NMCase')} />
                                                            <label htmlFor="option1">Normal Case</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 md:col-4 lg:col-4">
                                                        <div className="field-radiobutton">
                                                            <RadioButton inputId="option2" name="option" value={2} checked={scrutinyDetails?.NMCase === 2 || scrutinyDetails?.NMCase == true} onChange={(e) => handleChange(e.value, 'NMCase')} />
                                                            <label htmlFor="option2">Meeting Case</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </FormWizard.TabContent>
                        </FormWizard>

                        <div className="grid justify-content-between w-100 px-5">
                            <div>
                                {roleName == 'Sub Registar' && activeIndex == 1 ? <Button label="Back to Verification" onClick={() => scrutinyCheckOpen('Verification')}></Button> : null}
                                {roleName !== 'Sub Registar' && activeIndex === 0 ? <Button label="Back to Pending" onClick={() => scrutinyCheckOpen('Pending')}></Button> : null}
                            </div>

                            <div>
                                {(roleName === 'Scrutiny Manager' && activeIndex === 0) || (roleName === 'Sub Registar' && activeIndex == 1) ? (
                                    <Button label="Save" className="ml-2 p-button p-button-success" onClick={() => saveScrutiny()} loading={saveButtonLoader} />
                                ) : (
                                    <Button label="Save" disabled tooltip="Already RegNo is assigned / Don't have access" tooltipOptions={{ position: 'top' }} className="ml-2 p-button p-button-success" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scrutiny Success Modal Start */}
            {!window.cn(successDetails) && successDialog === true && <ScrutinySuccessModal openmodel={successDialog} title={'Re-Entry Scrutiny'} goToApp={() => goToApp()} data={{ fileNo, roleName, name, successDetails }} />}

            {/* Scrutiny Success Modal end */}

            {/* Scrutiny Check Modal Start */}
            <Dialog
                visible={scrutinyCheckDialog}
                className="p-fluid"
                style={{ width: '550px' }}
                header={!window.cn(scrutinyCheckBtnTitle) && 'Back to ' + scrutinyCheckBtnTitle}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => closeScrutinyCheckDialog()} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => checkScrutiny(scrutinyCheckBtnTitle)} loading={scrutinyCheckBtnSpinner} />
                    </>
                }
                onHide={() => closeScrutinyCheckDialog()}
            >
                <h5 className="bold">Are you sure want to transfer this application?</h5>
            </Dialog>

            {/* Scrutiny Check Modal End */}

            {/* Loader */}
            {pageLoad && <Loader />}
        </>
    );
};
